// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
// import Index from './index/index'
import Form from './form/form'

const routes = [
  // route('index', '/index', Index, professionalMeta('Lista de Estabelecimento')),
  // Desabilitado, deve haver somnete um cadastro de estabeçecimento
  // route('create', '/create', Form, professionalMeta('Adicionar Estabelecimento')),
  route('edit', '/me/edit', Form, professionalMeta('Editar Estabelecimento'))
]

export default subGroup('/companies', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/routes.js